import type { Messages } from '../i18n/messages';

/**
 * Nav module strings: the sidebar rail (SidebarRailView), the connected
 * SidebarRail (nav item labels), and the LogoIcon's accessible name.
 * "Regask" is the product brand — identical `en`/`fun` wherever it appears.
 */
export const navMessages: Messages = {
  'nav.sidebarRail.homeAriaLabel': {
    en: 'Regask home',
    fun: 'Back to Regask HQ',
  },
  'nav.sidebarRail.wordmark': { en: 'Regask', fun: 'Regask' },
  'nav.sidebarRail.collapseAriaLabel': {
    en: 'Collapse sidebar',
    fun: 'Fold it up',
  },
  'nav.sidebarRail.expandLabel': { en: 'Expand sidebar', fun: 'Unfurl it' },
  'nav.sidebarRail.searchLabel': { en: 'Search', fun: 'Snoop Around' },
  'nav.sidebarRail.quicklinksLabel': { en: 'Quicklinks', fun: 'Fast Lanes' },
  'nav.sidebarRail.notificationsLabel': {
    en: 'Notifications',
    fun: 'Pings',
  },
  'nav.sidebarRail.settingsLabel': { en: 'Settings', fun: 'Control Room' },
  'nav.sidebarRail.helpLabel': { en: 'Help', fun: 'SOS' },
  'nav.sidebarRail.feedbackLabel': {
    en: 'Send feedback',
    fun: 'Yell Into the Void',
  },
  'nav.sidebarRail.themeToLight': {
    en: 'Switch to light theme',
    fun: 'Blind Me (Light Mode)',
  },
  'nav.sidebarRail.themeToDark': {
    en: 'Switch to dark theme',
    fun: 'Go Stealth (Dark Mode)',
  },
  'nav.sidebarRail.profileAriaLabel': {
    en: 'User profile',
    fun: 'Your Corner',
  },
  'nav.sidebarRail.badgeAriaLabel': {
    en: '{label} ({count} unread)',
    fun: '{label} — {count} waiting on you',
  },
  'nav.sidebar.homeItem': { en: 'Home', fun: 'Home Base' },
  'nav.sidebar.catalogItem': { en: 'Catalog', fun: 'Vault' },
  'nav.sidebar.kubernetesItem': { en: 'Kubernetes', fun: 'Ship Yard' },
  'nav.sidebar.externalToolsItem': {
    en: 'External Tools',
    fun: 'Toolbox',
  },
  'nav.sidebar.deploymentsItem': { en: 'Deployments', fun: 'Deployments' },
  'nav.sidebar.queryItem': { en: 'Query', fun: 'Interrogation Room' },
  'nav.sidebar.approvalsItem': { en: 'Approvals', fun: 'Green Light' },
  'nav.sidebar.actionsItem': { en: 'Actions', fun: 'Button Mashing' },
  'nav.sidebar.adminItem': { en: 'Admin', fun: 'Mission Control' },
  'nav.sidebar.profileFallbackName': {
    en: 'Profile',
    fun: 'Mystery Guest',
  },
  'nav.logoIcon.ariaLabel': { en: 'Regask', fun: 'Regask' },
};
